// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"17d2e467","89":"7b5423e2","195":"233b49f7","205":"6ff558c3","274":"b46c3cdc","353":"2409354e","546":"75843d38","678":"33eb4dd5","744":"83518688","885":"7589ca0a","963":"e57b085a"}[chunkId] + ".chunk.js";
};